import { useCallback } from 'react';
import { NavigateFunction, NavigateOptions } from 'react-router';
import { useDebouncedCallback } from './useDebouncedCallback';

export const useDelayedRedirect = (navigate: NavigateFunction, delay: number) => {
  const redirect = useCallback(
    (path: string, options?: NavigateOptions) => {
      navigate(path, options);
    },
    [navigate],
  );
  const debouncedRedirect = useDebouncedCallback(redirect, delay);
  // If the delay is 0 or less, return the redirect function directly
  return delay <= 0 ? redirect : debouncedRedirect;
};
